import EA from '../helpers/init';

export default EA.Methods.tabSwitchHandler = ($this) => {
    const tabs = Array.from($this.querySelectorAll('.tabs-list [role="tab"]'));
    const panels = Array.from($this.querySelectorAll('.tabs-wrapper [role="tabpanel"]'));
    const mobileImages = Array.from($this.querySelectorAll('.current-tab-images .img-wrapper'));

    if (!tabs.length || !panels.length) return;

    // Resolve tab -> panel by aria-controls
    const getPanelForTab = (tab) => {
        const id = tab.getAttribute('aria-controls');
        if (!id) return null;
        return $this.querySelector(`#${CSS.escape(id)}`);
    };

    const setSelected = (nextTab, { focus = false } = {}) => {
        tabs.forEach((tab) => {
            const selected = tab === nextTab;

            tab.classList.toggle('active', selected);
            tab.setAttribute('aria-selected', selected ? 'true' : 'false');
            tab.tabIndex = selected ? 0 : -1;

            const panel = getPanelForTab(tab);
            if (panel) {
                panel.classList.toggle('active', selected);
                panel.tabIndex = 0;
            }
        });

        // Mobile images
        const index = tabs.indexOf(nextTab);
        if (index !== -1 && mobileImages.length) {
            mobileImages.forEach((img, i) => {
                const isActive = i === index;
                img.classList.toggle('active', isActive);
            });
        }

        if (focus) nextTab.focus();
    };

    const moveFocus = (fromTab, delta) => {
        const i = tabs.indexOf(fromTab);
        if (i === -1) return;
        const nextIndex = (i + delta + tabs.length) % tabs.length;
        tabs[nextIndex].focus();
    };

    // Init: find selected tab or fall back to first
    const initial = tabs.find(t => t.getAttribute('aria-selected') === 'true') || tabs[0];
    setSelected(initial);

    // Event handling
    tabs.forEach((tab) => {
        tab.addEventListener('click', () => setSelected(tab));

        tab.addEventListener('keydown', (e) => {
            switch (e.key) {
            case 'ArrowRight':
            case 'ArrowDown':
                e.preventDefault();
                moveFocus(tab, +1);
                break;
            case 'ArrowLeft':
            case 'ArrowUp':
                e.preventDefault();
                moveFocus(tab, -1);
                break;
            case 'Home':
                e.preventDefault();
                tabs[0].focus();
                break;
            case 'End':
                e.preventDefault();
                tabs[tabs.length - 1].focus();
                break;
            case 'Enter':
            case ' ':
                e.preventDefault();
                setSelected(tab);
                break;
            }
        });
    });
};